export function useBriefRenderer() {

  function renderBriefHTML(rawTekst) {
    let html = rawTekst
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')

    html = html.replace(/\{\{p:([a-z0-9_]+)=([^}]+)\}\}/gi, (m, key, label) => {
      return `<span class="placeholder" data-key="${key}">[${label}]</span>`
    })

    html = html.replace(/\{\{c:([a-z0-9_]+)=([^}]+)\}\}/gi, (m, key, value) => {
      return `<span class="computed" data-key="${key}">${value}</span>`
    })

    return html
  }

  function plainBriefTekst(rawTekst) {
    let txt = rawTekst.replace(/\{\{p:[a-z0-9_]+=([^}]+)\}\}/gi, '[$1]')
    txt = txt.replace(/\{\{c:[a-z0-9_]+=([^}]+)\}\}/gi, '$1')
    return txt
  }

  return {
    renderBriefHTML,
    plainBriefTekst
  }
}
